import React, { useEffect, useState } from 'react'
import { FaAngleLeft } from 'react-icons/fa6';
import { FaSearch } from "react-icons/fa";
import { MdOutlineDateRange } from "react-icons/md";
import { BsDownload } from "react-icons/bs";
import { FiPlus, FiPlusCircle, FiMinusCircle, FiCreditCard, FiSearch } from "react-icons/fi";

import MapSuccess from "../../../../assets/img/icon/map-success.svg"
import MapPending from "../../../../assets/img/icon/map-pending.svg"
import SwapImg from "../../../../assets/img/icon/coins-swap.svg"
import addIcon from '../../../../assets/img/icon/addIcon.png'
import { BsSendArrowUp, BsSendArrowDown } from "react-icons/bs";
import { SiConvertio } from 'react-icons/si';

import '../../Transactions/transactions.css';
import { useNavigate, useParams } from 'react-router-dom';
import { getVirtualCardActivities, verifyVirtualCardActivity } from '../../../../api/api';

const typeBadgeClasses = {
    success: "badge-success",
    pending: "badge-swapping",
    failed: "badge-danger",
};

const typeIcons = {
    credit: <BsSendArrowUp className="icon" size={20} />,
    swap: <SiConvertio className="icon text-dark" size={20} />,
    debit: <BsSendArrowDown className="icon " size={20} />,
};
const typeImages = {
    credit: <img src={MapSuccess} alt="Credit" className="icon" />,
    swap: <img src={SwapImg} alt="Swap" className="icon" />,
    debit: <img src={MapPending} alt="Debit" className="icon" />,
    create: <img src={MapSuccess} alt="Create" className="icon" />,
    fund: <img src={MapSuccess} alt="Fund" className="icon" />,
    withdraw: <img src={MapPending} alt="Withdraw" className="icon" />,
    terminate: <img src={MapPending} alt="Terminate" className="icon" />,
};

const CardTransactions = () => {
    const navigate = useNavigate();
    const { cardId } = useParams();
    const [userTransactions, setUserTransactions] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [ loading, setLoading ] = useState(false);
    const [ verifyingId, setVerifyingId ] = useState(null);
    const itemsPerPage = 10;

    const handleVerify = async (activityId) => {
        setVerifyingId(activityId);
        try {
            await verifyVirtualCardActivity(activityId);
            getUserTransactions(currentPage);
        } catch (error) {
            // console.error("Failed to verify activity", error);
        } finally {
            setVerifyingId(null);
        }
    };

    const getUserTransactions = async (pageNumber = 1) => {
        try {
            setLoading(true);
            const response = await getVirtualCardActivities(cardId, { page: pageNumber });   
            
            const { data, current_page, total_pages } = response.data?.data || {};

            setUserTransactions(data || []);
            setCurrentPage(current_page || 1);
            setTotalPages(total_pages || 1);
        } catch (error) {
            // console.error("Error fetching transactions:", error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getUserTransactions(currentPage);
    }, []);


    const transactions = [
        {
            id: 1,
            name: 'Transfer',
            type: 'pending',
            amount: '10,000.00',
            currency: 'NGN',
            description: 'OUTWARD TRANSFER (N) 2334647 To SAINT DANIEL CARDPLOT ID: 102938475',
            date: '31, December 2024',
            time: '06:39:43',
            reference: '/000038833834Y1TH0647499G4'
        },
        {
            id: 2,
            name: 'Airtime purchase',
            type: 'success',
            amount: '10,000.00',
            currency: 'NGN',
            description: 'OUTWARD TRANSFER (N) 2334647 To SAINT DANIEL CARDPLOT ID: 102938475',
            date: '29, December 2024',
            time: '06:39:43',
            reference: '/000038833834Y1TH0647499G4'
        },
        {
            id: 3,
            name: 'Fund wallet',
            type: 'pending',
            amount: '10,000.00',
            currency: 'NGN',
            description: 'OUTWARD TRANSFER (N) 2334647 To SAINT DANIEL CARDPLOT ID: 102938475',
            date: '28, December 2024',
            time: '06:39:43',
            reference: '/000038833834Y1TH0647499G4'
        },
        {
            id: 4,
            name: 'Netflix payment',
            type: 'success',
            amount: '10,000.00',
            currency: 'NGN',
            date: '27, December 2024',
            time: '06:39:43',
            description: 'OUTWARD TRANSFER (N) 2334647 To SAINT DANIEL CARDPLOT ID: 102938475',
        },
        {
            id: 5,
            name: 'Airtime purchase',
            type: 'success',
            amount: '10,000.00',
            currency: 'NGN',
            date: '25, December 2024',
            time: '06:39:43',
            description: 'OUTWARD TRANSFER (N) 2334647 To SAINT DANIEL CARDPLOT ID: 102938475',
        }
    ];

    const handleGoBack = () => {
        navigate(`/user/cards/${cardId || 1}`); 
    }
    const goToFundCard = () => {
        navigate(`/user/cards/card_option/${cardId || 1}`); 
    }

  return (
    <section className='create__card__page card__options__page pt-4' style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
            
            {/* Header */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4 mb-md-5">
                <div className="d-flex align-items-center">
                    <button onClick={handleGoBack} className="btn btn-light rounded-circle shadow-sm me-2 me-md-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', border: '1px solid #E0E4EC', flexShrink: 0 }}>
                        <FaAngleLeft size={16} color="#19064B" />
                    </button>
                    <h4 className="mb-0 fw-bold" style={{ color: '#19064B', fontSize: 'clamp(18px, 4.5vw, 24px)' }}>Card Transactions</h4>
                </div>
                <button onClick={goToFundCard} className="btn text-white d-flex align-items-center gap-2 shadow-sm rounded-pill px-3 px-md-4 py-2 ms-auto ms-sm-0" style={{ backgroundColor: '#0A95FF', fontSize: '14px' }}>
                    <FiPlus size={18} />
                    <span className="fw-medium">Fund Card</span>
                </button>
            </div>

            {/* Filter Section */}
            <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-between gap-3 mb-4 bg-white p-3 rounded-4 shadow-sm border" style={{ borderColor: '#E0E4EC' }}>
                <div className="position-relative flex-grow-1">
                    <FiSearch className="position-absolute text-muted" size={18} style={{ left: '16px', top: '50%', transform: 'translateY(-50%)' }} />
                    <input 
                        type="text" 
                        className="form-control border-0 bg-light" 
                        placeholder="Search for transaction..." 
                        style={{ paddingLeft: '45px', borderRadius: '12px', height: '48px' }} 
                    />
                </div>
                <div className="d-flex align-items-center gap-2 justify-content-between">
                    <div className="d-flex align-items-center bg-light px-3 rounded-3 flex-grow-1" style={{ height: '48px', minWidth: '0' }}>
                        <span className="text-muted small me-2 fw-medium text-truncate">17/01/2025 - 19/02/2025</span>
                        <MdOutlineDateRange size={20} className="text-muted flex-shrink-0 ms-auto" />
                    </div>
                    <button className="btn btn-light d-flex align-items-center justify-content-center border shadow-sm flex-shrink-0" style={{ width: '48px', height: '48px', borderRadius: '12px' }}>
                        <BsDownload size={18} color="#19064B" />
                    </button>
                </div>
            </div>

            {/* Transactions List */}
            {loading ? (
                <div className="text-center my-5 py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-5">
                    {userTransactions && userTransactions.length > 0 ? (
                        <div className="list-group list-group-flush">
                            {userTransactions.map((transaction) => {
                                const isSuccess = transaction.status === 'success' || transaction.status === 'completed';
                                const isFailed = transaction.status === 'failed';
                                const isPending = !isSuccess && !isFailed;
                                
                                return (
                                <div key={transaction.ref_id || transaction.id} className="list-group-item p-3 p-sm-4 d-flex align-items-center justify-content-between border-bottom gap-2">
                                    <div className="d-flex align-items-center gap-2 gap-sm-3 min-w-0">
                                        <div className={`d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 ${
                                            isSuccess ? 'bg-success bg-opacity-10 text-success' :
                                            isFailed ? 'bg-danger bg-opacity-10 text-danger' : 'bg-warning bg-opacity-10 text-warning'
                                        }`} style={{ width: '40px', height: '40px' }}>
                                            {transaction.operation_type === 'fund' ? <FiPlusCircle size={18} /> :
                                             transaction.operation_type === 'withdraw' ? <FiMinusCircle size={18} /> :
                                             transaction.operation_type === 'create' ? <FiCreditCard size={18} /> :
                                             <SiConvertio size={18} />}
                                        </div>
                                        <div className="min-w-0">
                                            <h6 className="mb-1 fw-bold text-dark text-capitalize text-truncate" style={{ fontSize: '14px' }}>{transaction.operation_type || transaction.type}</h6>
                                            <p className="mb-0 text-muted small text-truncate" style={{ fontSize: '11px' }}>
                                                {transaction.created_at && new Date(transaction.created_at).toLocaleString("default", { day: "numeric", month: "short", year: "numeric", hour: '2-digit', minute: '2-digit' })}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="text-end flex-shrink-0">
                                        <h6 className="mb-1 fw-bold text-dark" style={{ fontSize: '14px' }}>
                                            {transaction.operation_type === 'fund' ? '+' : transaction.operation_type === 'withdraw' ? '-' : ''}
                                            {transaction.amount} {transaction.currency}
                                        </h6>
                                        <div className="d-flex align-items-center justify-content-end gap-1 gap-sm-2 flex-wrap">
                                            <span className={`badge rounded-pill text-white ${
                                                isSuccess ? 'text-bg-success' : isFailed ? 'text-bg-danger' : 'text-bg-warning'
                                            }  text-capitalize`} style={{ fontSize: '10px', fontWeight: '600', padding: '5px 8px' }}>
                                                {transaction.status}
                                            </span>
                                            {isPending && (
                                                <button 
                                                    className="btn btn-sm btn-outline-primary rounded-pill px-2 py-0" 
                                                    style={{ fontSize: '10px', height: '20px', lineHeight: '18px' }}
                                                    onClick={() => handleVerify(transaction.id || transaction.ref_id)}
                                                    disabled={verifyingId === (transaction.id || transaction.ref_id)}
                                                >
                                                    {verifyingId === (transaction.id || transaction.ref_id) ? "..." : "Verify"}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )})}
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <div className="mb-3">
                                <SiConvertio size={48} color="#E0E4EC" />
                            </div>
                            <h5 className="fw-semibold text-dark mb-1">No Transactions Yet</h5>
                            <p className="text-muted">You haven't made any transactions with this card.</p>
                            <button onClick={goToFundCard} className="btn btn-primary rounded-pill mt-2 px-4 shadow-sm">
                                Fund Card Now
                            </button>
                        </div>
                    )}
                </div>
            )}
            
            {/* Pagination */}
            {!loading && userTransactions && userTransactions.length > 0 && totalPages > 1 && (
                <div className="dash-txn-pagination d-flex align-items-center justify-content-center gap-3 mt-4 mb-5 pb-5">
                    <button
                        type="button"
                        onClick={() => setCurrentPage((page) => Math.max(1, page - 1))}
                        disabled={currentPage === 1 || loading}
                        aria-label="Previous transactions page"
                    >
                        ‹
                    </button>
                    <span>Page {currentPage} of {totalPages}</span>
                    <button
                        type="button"
                        onClick={() => setCurrentPage((page) => Math.min(totalPages, page + 1))}
                        disabled={currentPage === totalPages || loading}
                        aria-label="Next transactions page"
                    >
                        ›
                    </button>
                </div>
            )}

        </div>
    </section>
  )
}
export default CardTransactions;